import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.scss']
})
export class ConfirmEmailComponent implements OnInit {
  confirmationMessage = '';

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      const token = params.get('confirm-email');
      if (!token) {
        this.confirmationMessage = '❌ Aucun token de confirmation trouvé.';
        return;
      }
  
      this.http.get(`http://localhost:1337/api/auth/email-confirmation?confirmation=${token}`)
        .subscribe({
          next: () => {
            this.confirmationMessage = '✅ Votre compte a bien été confirmé. Vous pouvez maintenant vous connecter.';
          },
          error: () => {
            this.confirmationMessage = '❌ Le lien est invalide ou a expiré.';
          }
        });
    });
  }
  
  
  
}
